import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AnalyticsComponent } from './analytics.component';
import { AnalyticsContainerComponent } from './components/analytics-container/analytics-container.component';

const routes: Routes = [
  {
    path: '',
    component: AnalyticsComponent,
    data: { breadcrumb: { label: 'Analytics' } },
    children: [
      {
        path: '',
        component: AnalyticsContainerComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AnalyticsRoutingModule {}
